<template>
    <app-layout title="Nastavení">

        <settings-tabs-navigation/>

        <div class="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">

            <div v-if="!$page.props.selectedUser" class="mb-4">
                <info-bar color="orange"> Některá nastavení jsou pro každou schránku individuální. Bez datové schránky je nepůjde nastavit.  </info-bar>
            </div>

            <info-bar v-if="$page.props.selectedUser"> Tato sekce je pro každou schránku individuální. Právě spravujete "{{ $page.props.selectedUser.name }}" </info-bar>
            <jet-form-section :class="!$page.props.selectedUser ? 'opacity-25' : ''"
                              @submitted="saveSettings(settingsDownloading)"
                              :working="settingsDownloading.processing">
                <template #title>
                    Stahování zpráv
                </template>

                <template #description>
                    Zde si můžete vybrat, kdy se budou stahovat nové zprávy a chování při přidání nového účtu ISDS.
                </template>

                <template #form>
                    <div class="flex items-start col-span-6">
                        <div class="flex items-center h-5">
                            <input :disabled="!$page.props.selectedUser" v-model="settingsDownloading.settings.automatic_delivery" id="automatic_delivery" name="automatic_delivery" type="checkbox" class="border-solid border-2 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="automatic_delivery" class="font-medium text-gray-700">Automatické stahování</label>
                            <p class="text-gray-500">Chci automaticky stahovat nové zprávy při přihlášení a během práce v DSchránce.</p>
                        </div>
                    </div>
                    <div class="flex items-start col-span-6">
                        <div class="flex items-center h-5">
                            <input :disabled="!$page.props.selectedUser" v-model="settingsDownloading.settings.initial_import" id="initial_import" name="initial_import" type="checkbox" class="border-solid border-2 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="initial_import" class="font-medium text-gray-700">Automatický import</label>
                            <p class="text-gray-500">Chci stáhnout historii zpráv (zprávy odeslané nebo přijaté před připojením schránky).</p>
                        </div>
                    </div>
                    <div class="flex items-start col-span-6">
                        <div class="flex items-center h-5">
                            <input :disabled="!$page.props.selectedUser" @change="uncheckDisabled" v-model="settingsDownloading.settings.bg_download" id="bg_download" name="bg_download" type="checkbox" class="border-solid border-2 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="bg_download" class="font-medium text-gray-700">Stahování v nepřítomnosti</label>
                            <p class="text-gray-500">Chci, aby DSchránka stahovala nové zprávy i bez mého přihlášení.</p>
                        </div>
                    </div>
                    <div class="flex items-start ml-8 col-span-6">
                        <div class="flex items-center h-5">
                            <input v-model="settingsDownloading.settings.bg_download_notif" :disabled="!settingsDownloading.settings.bg_download || !$page.props.selectedUser" id="bg_download_notif" name="bg_download_notif" type="checkbox" class="border-solid border-2 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded disabled:opacity-50">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="bg_download_notif" class="font-medium text-gray-700">Přeposílání emailem</label>
                            <p class="text-gray-500">Chci takové zprávy přeposílat na email.</p>
                        </div>
                    </div>
                    <div class="flex items-start ml-8 col-span-6 opacity-25">
                        <div class="flex items-center h-5">
                            <input :disabled="true" id="bg_download_notif" name="bg_download_notif" type="checkbox" class="border-solid border-2 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded disabled:opacity-50">
                        </div>
                        <div class="ml-3 text-sm">
                            <label for="bg_download_notif" class="font-medium text-gray-700">Pouze obálky <span class="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">Již brzy</span></label>
                            <p class="text-gray-500">Bude stažen jen odesílatel a předmět zprávy, ale zpráva tímto nebude doručena. </p>
                        </div>
                    </div>

                </template>
                <template #actions>
                    <jet-action-message :on="settingsDownloading.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsDownloading.processing }" :disabled="settingsDownloading.processing || !$page.props.selectedUser">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>

            <jet-section-border />

            <info-bar v-if="$page.props.selectedUser"> Tato sekce je pro každou schránku individuální. Právě spravujete "{{ $page.props.selectedUser.name }}" </info-bar>
            <jet-form-section :class="!$page.props.selectedUser ? 'opacity-25' : ''" @submitted="saveSettings(settingsPasswords)" :working="settingsPasswords.processing">
                <template #title>
                    Zabezpečení
                </template>
                <template #description>
                    Vyberte si, jak DSchránka pracuje s hesly k vašim schránkám.
                </template>
                <template #form>
                    <div class="col-span-6">
                        <legend class="text-base font-medium text-gray-900">Automatická změna hesla</legend>
                        <p class="text-sm text-gray-500">DSchránka může kontrolovat platnost vašich hesel a včas je měnit, abyste mohli pracovat bezstarostně a bez přerušování. Hesla si můžete na vyžádání zobrazit, když je budete potřebovat.</p>
                    </div>
                    <div class="mt-4 space-y-4 col-span-6">
                        <div class="flex items-center">
                            <input :disabled="!$page.props.selectedUser" v-model="settingsPasswords.settings.manage_passwords" id="manage_passwords_yes" name="manage_passwords" type="radio" value="1" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                            <label for="manage_passwords_yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Chci, aby DSchránka spravovala hesla k mým schránkám.
                            </label>
                        </div>
                        <div class="flex items-center">
                            <input :disabled="!$page.props.selectedUser" v-model="settingsPasswords.settings.manage_passwords" id="manage_passwords_no" name="manage_passwords" type="radio" value="0" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                            <label for="manage_passwords_no" class="ml-3 block text-sm font-medium text-gray-700">
                                Chci si hesla spravovat sám. <br><i>(nové heslo bude vždy nutné zadat i do DSchránky)</i>
                            </label>
                        </div>
                    </div>
                </template>
                <template #actions>
                    <jet-action-message :on="settingsPasswords.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsPasswords.processing }" :disabled="settingsPasswords.processing || !$page.props.selectedUser">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>

            <jet-section-border />

            <jet-form-section :class="!features.includes('longterm') ? 'opacity-25' : ''" @submitted="saveSettings(settingsLongTerm)" :working="settingsLongTerm.processing">
                <template #title>
                    Dlouhodobé úložiště
                </template>

                <template #description>
                    Díky DSchránce máte možnost své zprávy dlouhodobě uchovávat zdarma na pomalejším úložišti! Takové zprávy se mohou načítat trochu déle v závislosti na jejich velikosti.
                </template>

                <template #form>
                    <div class="col-span-6">
                        <legend class="text-base font-medium text-gray-900">Dlouhodobé úložiště</legend>
                        <p class="text-sm text-gray-500"> Přejete si archivovat zprávy na dlouhodobém úložišti?</p>
                    </div>
                    <div class="space-y-4 col-span-6">
                        <div class="flex items-center">
                            <input :disabled="!features.includes('longterm')" v-model="settingsLongTerm.enabled" id="long_term_yes" type="radio" value="1" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                            <label for="long_term_yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Ano, archivovat zprávy.
                            </label>
                        </div>
                        <div class="flex items-center ml-8 col-span-6">
                            <div>
                                <label for="long_term_threshold" class="block text-sm font-medium text-gray-700">Po jaké době budeme zprávy archivovat?</label>
                                <select :required="settingsLongTerm.enabled" v-model="settingsLongTerm.settings.long_term_threshold" :disabled="!settingsLongTerm.enabled || settingsLongTerm.enabled === '0'" id="long_term_threshold" name="long_term_threshold" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                                    <option v-for="(option, index) in longTermThresholdOptions" :value="index"> {{ option }} </option>
                                </select>
                            </div>

                        </div>
                        <div class="flex items-center col-span-6">
                            <input :disabled="!features.includes('longterm')" v-model="settingsLongTerm.enabled" id="long_term_no" type="radio" value="0" class="border-solid border-2 border-gray-100 bg-gray-100 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                            <label for="long_term_no" class="ml-3 block text-sm font-medium text-gray-700">
                                Ne, nechci zprávy archivovat zdarma na pomalejším úložišti.
                            </label>
                        </div>
                    </div>
                </template>

                <template #actions>
                    <jet-action-message :on="settingsLongTerm.recentlySuccessful" class="mr-3">
                        Uloženo.
                    </jet-action-message>
                    <jet-button type="submit" :class="{ 'opacity-25': settingsLongTerm.processing, 'cursor-default' : !features.includes('longterm') }" :disabled="settingsLongTerm.processing || !features.includes('longterm')">
                        Uložit
                    </jet-button>
                </template>
            </jet-form-section>

        </div>

    </app-layout>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout";
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDangerButton from '@/Jetstream/DangerButton'
import SettingsTabsNavigation from "./SettingsTabsNavigation";
import InfoBar from "../../Components/InfoBar.vue";

export default {
    name: "SettingsDS",
    components: {
        InfoBar,
        SettingsTabsNavigation,
        AppLayout,
        JetSectionBorder,

        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetDangerButton,
    },
    data() {
        console.log(this.$page.props.features);
        console.log(this.$page.props.settingsDS.long_term_threshold);
        return {
            settingsDownloading: {
                processing: false,
                recentlySuccessful: false,

                referer: 'settingsDS',
                name: 'settingsDownloading',
                route: 'settings.isds.settings',

                settings: {
                    automatic_delivery: !!this.$page.props.selectedUser?.settings?.automatic_delivery,
                    initial_import: !!this.$page.props.selectedUser?.settings?.initial_import,
                    bg_download: !!this.$page.props.selectedUser?.settings?.bg_download,
                    bg_download_notif: !!this.$page.props.selectedUser?.settings?.bg_download_notif,
                }
            },
            settingsPasswords: {
                processing: false,
                recentlySuccessful: false,

                referer: 'settingsDS',
                name: 'settingsPasswords',
                route: 'settings.isds.settings',

                settings: {
                    manage_passwords: this.$page.props.selectedUser?.settings?.manage_passwords
                }
            },

            settingsLongTerm: {
                processing: false,
                recentlySuccessful: false,

                referer: 'settingsDS',
                name: 'settingsLongTerm',
                route: 'settings',

                enabled: this.$page.props.settingsDS.long_term_threshold != null ? '1' : '0',
                settings: {
                    long_term_threshold: this.$page.props.settingsDS.long_term_threshold != null ? this.$page.props.settingsDS.long_term_threshold : 3 //null = disabled
                }
            },
            longTermThresholdOptions: this.$page.props.longTermThresholdOptions,

            features: this.$page.props.features,

        }
    },
    methods: {
        uncheckDisabled(){
            if(this.settingsDownloading.settings.bg_download === false) this.settingsDownloading.settings.bg_download_notif = false;
        },
        saveSettings(settings){
            if(settings.name === 'settingsDownloading') this.settingsDownloading.processing = true;
            if(settings.name === 'settingsPasswords') this.settingsPasswords.processing = true;
            if(settings.name === 'settingsLongTerm') this.settingsLongTerm.processing = true;

            this.$inertia.post(route(settings.route), settings, {
                preserveScroll: true,
                preserveState: settings.name !== 'settingsLongTerm',
                onSuccess: (response) => {
                    this.indicateSaveStatus(settings);
                }
            });
        },
        indicateSaveStatus(settings){
            if(settings.name === 'settingsDownloading') {
                this.settingsDownloading.recentlySuccessful = true;
                setTimeout(() => { this.settingsDownloading.recentlySuccessful = false }, 1000);
                this.settingsDownloading.processing = false;
            }
            if(settings.name === 'settingsPasswords') {
                this.settingsPasswords.recentlySuccessful = true;
                setTimeout(() => { this.settingsPasswords.recentlySuccessful = false }, 1000);
                this.settingsPasswords.processing = false;
            }
            if(settings.name === 'settingsLongTerm') {
                this.settingsLongTerm.recentlySuccessful = true;
                setTimeout(() => { this.settingsLongTerm.recentlySuccessful = false }, 1000);
                this.settingsLongTerm.processing = false;
            }
        },
        debug(){
            console.log(this.settingsLongTerm.settings)
        }
    },
}
</script>

<style scoped>

</style>
